import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateClient } from "../../api/apiClients";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

/**
 * Hook لتحديث عميل
 */
export function useUpdateClient() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: updateClientMutate,
        isPending,
    } = useMutation({
        mutationFn: ({ id, data }) => updateClient(id, data),
        onSuccess: (response) => {
            toast.success(response.message || "Updated successfully");
            queryClient.invalidateQueries({ queryKey: ["clients"] });
            navigate('/clients');
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update client");
        },
    });

    return {
        updateClientMutate,
        isPending,
    };
}